import { useQuery } from 'data-fetching-client';
import { getI18nLangLocale } from 'pricing-pages-lib/utils/languageUtils';
import { GET_TRANSLATED_PRIORITY_FEATURES_QUERY } from '../../../../__generated__/chirp/com/hubspot/feature/store/rpc/PriorityFeaturesRpc.dfc.new';
const usePriorityFeaturesForApiName = ({
  productApiName
}) => {
  const langLocale = getI18nLangLocale();
  const {
    data,
    loading
  } = useQuery(GET_TRANSLATED_PRIORITY_FEATURES_QUERY, {
    variables: {
      productApiName,
      i18nLangLocale: langLocale
    },
    skip: !productApiName
  });
  return {
    priorityFeatures: (data === null || data === void 0 ? void 0 : data.result.priorityFeatures) || [],
    loading
  };
};
export const usePriorityFeaturesForApiNameHideFromLang = ({
  productApiName
}) => {
  const {
    priorityFeatures,
    loading
  } = usePriorityFeaturesForApiName({
    productApiName
  });
  return {
    priorityFeatures: priorityFeatures.filter(feature => !feature.hideFromLang),
    loading
  };
};
export const useCategorizedPriorityFeatures = ({
  apiName
}) => {
  const {
    loading,
    priorityFeatures: features
  } = usePriorityFeaturesForApiNameHideFromLang({
    productApiName: apiName
  });
  const brandingAndLimitFeatures = features.filter(feature => feature.featureType === 'LIMIT_INCREASE' || feature.featureType === 'REMOVE_BRANDING');
  const uncategorizedFeatures = features.filter(feature => !feature.featureType);
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};
export const usePriorityFeaturesFilteredByFreeUserAccessLevel = ({
  apiName,
  requiresPaidSeat,
  featureCountLimit
}) => {
  const {
    priorityFeatures,
    loading
  } = usePriorityFeaturesForApiNameHideFromLang({
    productApiName: apiName
  });

  //  Filter based on requiresPaidSeat input
  const filteredAndSortedFeatures = priorityFeatures.filter(feature => {
    const requiresSeat = feature.freeUserAccessLevel === 'NO_ACCESS' || feature.freeUserAccessLevel === 'LIMITED_ACCESS';
    return requiresPaidSeat === requiresSeat;
  }).sort((a, b) => a.featureId - b.featureId);
  const filteredFeatures = featureCountLimit ? filteredAndSortedFeatures.slice(0, featureCountLimit) : filteredAndSortedFeatures;
  return {
    loading,
    features: filteredFeatures
  };
};